function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["className", "triggerOnEnter", "actions", "children", "altHref", "icon", "color"],
    _excluded2 = ["divider", "text", "altHref", "icon", "onClick", "confirm", "confirmWithText", "confirmWithBody", "disabledMessage"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import Icon, { DownOutlined } from '@ant-design/icons';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Button, Dropdown, Menu, Tooltip } from 'antd';
import * as randomstring from 'randomstring';
import { preventDefault } from '../../utils/prevent';
import { getClassNames } from '../../utils/getClassNames';
import Modal from '../modal';

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      loading: false
    };
    _this.unmounting = false;

    _this.handleKeyDown = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ev) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(ev.key && ev.key.toUpperCase() === 'ENTER')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", _this.handleClick());

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleClick = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(ev, confirmed) {
        var shouldPerformNative;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                shouldPerformNative = _this.props.altHref && (ev || {}).metaKey;

                if (shouldPerformNative) {
                  _context3.next = 13;
                  break;
                }

                if (ev) preventDefault(ev);

                if (!_this.state.loading) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:
                if (!(!_this.props.confirm || confirmed === true)) {
                  _context3.next = 12;
                  break;
                }

                _this.setState({
                  loading: true
                });

                _context3.next = 9;
                return _this.props.onClick();

              case 9:
                if (!_this.unmounting) {
                  _this.setState({
                    loading: false
                  });
                }

                _context3.next = 13;
                break;

              case 12:
                if (_this.props.confirm) {
                  Modal.confirm(_objectSpread(_objectSpread({
                    okText: 'Confirm'
                  }, _this.props.confirm), {}, {
                    onOk: function () {
                      var _onOk = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                        return regeneratorRuntime.wrap(function _callee2$(_context2) {
                          while (1) {
                            switch (_context2.prev = _context2.next) {
                              case 0:
                                return _context2.abrupt("return", _this.handleClick(null, true));

                              case 1:
                              case "end":
                                return _context2.stop();
                            }
                          }
                        }, _callee2);
                      }));

                      function onOk() {
                        return _onOk.apply(this, arguments);
                      }

                      return onOk;
                    }()
                  }));
                }

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.handleActionItemClick = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(item, confirmed) {
        var ev, action, shouldPerormNative;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                ev = item.domEvent;
                action = _this.props.actions.find(function (a) {
                  return (a.key || a.text) === item.key;
                });
                shouldPerormNative = action.altHref && ev && ev.metaKey;

                if (shouldPerormNative) {
                  _context7.next = 12;
                  break;
                }

                if (!(!action.confirmWithBody && !action.confirmWithText && !action.confirm || confirmed === true)) {
                  _context7.next = 9;
                  break;
                }

                _context7.next = 7;
                return action.onClick(item.item);

              case 7:
                _context7.next = 12;
                break;

              case 9:
                if (action.confirm) {
                  Modal.confirm(_objectSpread(_objectSpread({
                    okText: 'Confirm'
                  }, action.confirm), {}, {
                    onOk: function () {
                      var _onOk2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                        return regeneratorRuntime.wrap(function _callee4$(_context4) {
                          while (1) {
                            switch (_context4.prev = _context4.next) {
                              case 0:
                                return _context4.abrupt("return", _this.handleActionItemClick(item, true));

                              case 1:
                              case "end":
                                return _context4.stop();
                            }
                          }
                        }, _callee4);
                      }));

                      function onOk() {
                        return _onOk2.apply(this, arguments);
                      }

                      return onOk;
                    }()
                  }));
                }

                if (action.confirmWithText) {
                  Modal.confirmWithTextInput(_objectSpread(_objectSpread({
                    okText: 'Confirm'
                  }, action.confirmWithText), {}, {
                    onOk: function () {
                      var _onOk3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                        return regeneratorRuntime.wrap(function _callee5$(_context5) {
                          while (1) {
                            switch (_context5.prev = _context5.next) {
                              case 0:
                                return _context5.abrupt("return", _this.handleActionItemClick(item, true));

                              case 1:
                              case "end":
                                return _context5.stop();
                            }
                          }
                        }, _callee5);
                      }));

                      function onOk() {
                        return _onOk3.apply(this, arguments);
                      }

                      return onOk;
                    }()
                  }));
                }

                if (action.confirmWithBody) {
                  Modal.confirmWithCustomBody(_objectSpread(_objectSpread({
                    okText: 'Confirm'
                  }, action.confirmWithBody), {}, {
                    onOk: function () {
                      var _onOk4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                        return regeneratorRuntime.wrap(function _callee6$(_context6) {
                          while (1) {
                            switch (_context6.prev = _context6.next) {
                              case 0:
                                return _context6.abrupt("return", _this.handleActionItemClick(item, true));

                              case 1:
                              case "end":
                                return _context6.stop();
                            }
                          }
                        }, _callee6);
                      }));

                      function onOk() {
                        return _onOk4.apply(this, arguments);
                      }

                      return onOk;
                    }()
                  }));
                }

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x4, _x5) {
        return _ref3.apply(this, arguments);
      };
    }();

    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.wireEvents();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmounting = true;
      this.unwireEvents();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          triggerOnEnter = _this$props.triggerOnEnter,
          actions = _this$props.actions,
          children = _this$props.children,
          altHref = _this$props.altHref,
          primaryIcon = _this$props.icon,
          color = _this$props.color,
          props = _objectWithoutProperties(_this$props, _excluded);

      var classNames = getClassNames('btn', className, {
        'with-actions': !!actions
      });
      var iconType = primaryIcon;
      var iconTheme;
      var iconProps = {};

      if (!!primaryIcon && typeof primaryIcon === 'string') {
        var iconParts = primaryIcon.split(':');
        iconType = iconParts[0];

        if (iconParts.length > 1) {
          iconTheme = iconParts[1];
        }

        if (!!color) {
          iconProps.style = {
            color: color
          };
        }
      }

      var primaryContent = /*#__PURE__*/React.createElement(React.Fragment, null, iconType && (typeof iconType === 'string' ? /*#__PURE__*/React.createElement(LegacyIcon, _extends({
        type: iconType,
        theme: iconTheme
      }, iconProps)) : /*#__PURE__*/React.createElement(LegacyIcon, {
        component: iconType
      })), children);
      return actions ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, _extends({}, props, {
        className: classNames,
        loading: this.state.loading,
        onClick: this.handleClick
      }), altHref ? /*#__PURE__*/React.createElement("a", {
        onClick: preventDefault,
        href: altHref
      }, primaryContent) : primaryContent), /*#__PURE__*/React.createElement(Dropdown, {
        placement: "bottomRight",
        overlay: /*#__PURE__*/React.createElement(Menu, {
          className: getClassNames('dropdown-actions'),
          onClick: this.handleActionItemClick
        }, actions.map(function (action) {
          var divider = action.divider,
              text = action.text,
              actionAltHref = action.altHref,
              icon = action.icon,
              onClick = action.onClick,
              confirm = action.confirm,
              confirmWithText = action.confirmWithText,
              confirmWithBody = action.confirmWithBody,
              disabledMessage = action.disabledMessage,
              actionProps = _objectWithoutProperties(action, _excluded2);

          if (divider) {
            return /*#__PURE__*/React.createElement(Menu.Divider, {
              key: "div_".concat(randomstring.generate())
            });
          }

          var itemContent = actionAltHref ? /*#__PURE__*/React.createElement("a", {
            onClick: preventDefault,
            href: actionAltHref
          }, icon && (typeof icon === 'string' ? /*#__PURE__*/React.createElement(LegacyIcon, {
            type: icon
          }) : /*#__PURE__*/React.createElement(Icon, {
            component: icon
          })), /*#__PURE__*/React.createElement("span", null, text)) : /*#__PURE__*/React.createElement("span", null, icon && (typeof icon === 'string' ? /*#__PURE__*/React.createElement(LegacyIcon, {
            type: icon
          }) : /*#__PURE__*/React.createElement(Icon, {
            component: icon
          })), /*#__PURE__*/React.createElement("span", null, text));
          return /*#__PURE__*/React.createElement(Menu.Item, _extends({
            key: text
          }, actionProps), actionProps.disabled && !!disabledMessage ? /*#__PURE__*/React.createElement(Tooltip, {
            title: disabledMessage
          }, itemContent) : itemContent);
        }))
      }, /*#__PURE__*/React.createElement(Button, {
        type: props.type,
        size: props.size
      }, /*#__PURE__*/React.createElement(DownOutlined, null)))) : /*#__PURE__*/React.createElement(Button, _extends({}, props, {
        className: classNames,
        loading: this.state.loading,
        onClick: this.handleClick
      }), altHref ? /*#__PURE__*/React.createElement("a", {
        onClick: preventDefault,
        href: altHref
      }, primaryContent) : primaryContent);
    }
  }, {
    key: "wireEvents",
    value: function wireEvents() {
      if (this.props.triggerOnEnter) {
        document.addEventListener('keydown', this.handleKeyDown);
      }
    }
  }, {
    key: "unwireEvents",
    value: function unwireEvents() {
      if (this.props.triggerOnEnter) {
        document.removeEventListener('keydown', this.handleKeyDown);
      }
    }
  }]);

  return _default;
}(React.Component);

export { _default as default };